import { HudIcon } from '../../../../Icons/HudIcons';
import { Container } from "./EntityTotalCard.styles";
// TODO replace this with new design system skeleton
import Skeleton from '../../../../Skeleton/Skeleton';

type TopLevelNumberCardProps = {
  entityType: 'endpoint' | 'queue' | 'function';
  calledFigure?: number;
  mappedFigure?: number;
  url: string;
  isLoading?: boolean
};

const verbMap = {
  endpoint: 'Called',
  queue: 'Called',
  function: 'Invoked'
}

const EntityTotalCard: React.FC<TopLevelNumberCardProps> = ({
  entityType,
  calledFigure,
  mappedFigure,
  url,
  isLoading
}) => {
  const hasData = entityType && calledFigure !== undefined && mappedFigure !== undefined;
  const entityCapitalized =`${entityType.charAt(0).toUpperCase()}${entityType.slice(1)}s`;

  if (!hasData || isLoading) {
    return <Container href={url}>
      <div className="cardHeader">
        {entityCapitalized}
        <HudIcon icon={`designSystem.${entityType}`} size={'20px'} />
      </div>
      <div className="mainFigure"><Skeleton width="100%" /></div>
      <div className="secondaryFigure"><Skeleton width="100%" /></div>
    </Container>
  } else {
    return <Container href={url}>
      <div className="cardHeader">
        {entityCapitalized}
        <HudIcon icon={`designSystem.${entityType}`} size={'20px'} />
      </div>
      <div className="mainFigure">{calledFigure.toLocaleString()} <span className="verb">{verbMap[entityType]}</span></div>
      <div className="secondaryFigure">{mappedFigure.toLocaleString()} <span className="verb">Mapped</span></div>
    </Container>
  }
}

export default EntityTotalCard;
